import { render, staticRenderFns } from "./FarmUser.vue?vue&type=template&id=28909aaa&scoped=true"
import script from "./FarmUser.vue?vue&type=script&lang=js"
export * from "./FarmUser.vue?vue&type=script&lang=js"
import style0 from "./FarmUser.vue?vue&type=style&index=0&id=28909aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28909aaa",
  null
  
)

export default component.exports